export const stateStageEnum = Object.freeze({
    HISTORY:    1,
    CURRENT:    2,
    FUTURE:     3
});